module.exports = __webpack_public_path__ + "resources/groups-1e57cc7e712a7fab091ec46f0a9526c9.svg";